import React from 'react';
import {AlertTriangleIcon, PlusIcon, XIcon} from '../Icons';

interface ProjectsToolbarProps {
  onCreate: () => void;
  error: string | null;
  onDismissError: () => void;
}

/** The page's primary action, in the one style reserved for it. Also the empty state's CTA. */
export const NewProjectButton: React.FC<{onClick: () => void}> = ({onClick}) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex items-center gap-1.5 rounded-lg bg-indigo-600 px-3 py-1.5 text-xs
     font-medium text-white hover:bg-indigo-500 transition-colors cursor-pointer"
  >
    <PlusIcon className="w-3.5 h-3.5" />
    New project
  </button>
);

/**
 * Title, what a project is for, and the one way to make another.
 *
 * Creating used to unfold a form panel above the grid, which pushed the list the user was reading
 * off the screen. It is a dialog now, on the same shell as every other one.
 */
const ProjectsToolbar: React.FC<ProjectsToolbarProps> = ({onCreate, error, onDismissError}) => (
  <>
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-xl font-semibold text-gray-50">Projects</h1>
        <p className="mt-0.5 text-sm text-gray-500">
          A project keeps its own audio files, transcriptions and default word list. Open one to
          work in it.
        </p>
      </div>
      <NewProjectButton onClick={onCreate} />
    </div>

    {error && (
      <div className="flex items-start gap-2 rounded-lg border border-red-500/30 bg-red-500/[0.06]
       px-3 py-2.5 text-sm text-red-200">
        <AlertTriangleIcon className="mt-0.5 w-4 h-4 shrink-0" />
        <p className="flex-1">{error}</p>
        <button
          type="button"
          onClick={onDismissError}
          aria-label="Dismiss error"
          className="shrink-0 text-red-300/70 hover:text-red-200 cursor-pointer"
        >
          <XIcon className="w-4 h-4" />
        </button>
      </div>
    )}
  </>
);

export default ProjectsToolbar;
